/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML';
import update from 'react-addons-update'; // ES6
import moment from 'moment'
import { default as DT } from 'react-datetime'
import Select, { components } from 'react-select';
import Pagination from "./pagination";

var _ = require('lodash');

import ReactTable from "react-table"
import "react-table/react-table.css"
const selectrender = props => {
  return (
    <components.Option {...props}>
      <div>{props.data.label}</div>
      <div style={{ fontSize: 12 }}>{props.data.subLabel}</div>
    </components.Option>
  );
};
// import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.key;

class Agenda extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",
      md: SectionConfig.md,
      sv: SectionConfig.sv,
      canDeleteApp: false,
      updatetrack: false,
      updateinfobooth: false,
      selectedtrack: {},
      selectedtrackname: '',
      trackname: '',
      infoboothname: '',
      sectionsactive: ["active", "", "", ""],
      trackvalue: '',
      infoboothdes: '',
      selectedinfobooth: {},
      selectedinfoboothname: '',

      tzo: 0,
      speakerlocation: "",
      speakersessiontype: { label: "MainSession", value: false },
      speakervenue: null,
      speakeredate: "",
      speakersdate: '',
      authortracks: [],
      authorlist: [],
      agendatracks: [],
      agendalist: [],
      speakertrack: "",
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerdes: "",
      columns: [],
      tdata: [],
      updatedspeaker: false,
      selectedspeaker: {}
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.processDataForSaving = this.processDataForSaving.bind(this);
    this.appendSection = this.appendSection.bind(this);
    this.saveAppInfo = this.saveAppInfo.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";
    this.confirmDeleteApp = this.confirmDeleteApp.bind(this);
    this.getAutoIncrementedNumOfApps = this.getAutoIncrementedNumOfApps.bind(this);
    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }


  componentDidMount() {

  }

  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }


  doDeleteauthor() {
    console.log("Deleted in author");
    var key = this.state.selectedspeaker.key;
    console.log("Updat e redux state");
    console.log(key);
    if (!this.state.selectedspeaker.ms) {
      var found = false;
      this.state.agendalist.map(agenda => {
        if (agenda.ms) {
          if (agenda.ms == this.state.selectedspeaker.key) {
            found = true
          }
        }

      })
      if (found) {
        alert("This Section contain subsection please update them");
        this.refs.deleteDialogauthor.hide()

        return;
      }
    }
    this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, subtype: "agenda", data: undefined })
    console.log("Updating local state");
    this.setState({
      agendalist: this.state.agendalist.filter(el => (el.key === this.state.selectedspeaker.key ? false : true)),
      selectedspeaker: {}
    }, () => {
      console.log("hhh");
      console.log(this.state.agendalist);
    });
    var update = {};
    update['myapps/' + this.props.params.sub + "/" + this.props.route.type + "/agenda/" + key] = null;
    if (this.state.selectedspeaker.ms) {
      update['myapps/' + this.props.params.sub + "/" + this.props.route.type + "/agenda/" + this.state.selectedspeaker.ms + "/ss/" + this.state.selectedspeaker.key] = null;
    }
    // console.log(this.state.selectedspeaker);
    // console.log(update);
    firebase.app.database().ref().update(update);
    this.refs.deleteDialogauthor.hide()

  }
  doDelete() {
    console.log("Do delete ");
    console.log();
    console.log("Item to delete: " + this.state.pathToDelete);
    var found = false;
    this.state.agendalist.map(author => {
      if (author.track == this.state.pathToDelete) {
        found = true;
      }
    })
    if (found) {
      console.log("Author already exists");
      alert("Track Associated with agenda. Please update agendas.")
      return;
    } else {
      console.log("Do delete");
      var nodes = removeNodeAtPath({
        treeData: this.state.agendatracks,
        path: this.state.pathToDelete,
        getNodeKey: ({ node }) => node.key,
      })
      // this.setState({
      //   authortracks:nodes
      // })

      this.setState({
        agendatracks: nodes
      }, () => {
        var tosavelist = {};
        nodes.map((d, i) => {
          tosavelist[d.key] = { name: d.title, o: i }
        })
        console.log(tosavelist);
        firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/tracks").set(tosavelist);
        this.props.updateobjectdatabytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: "tracks", data: tosavelist });
      });

      // var key = this.state.pathToDelete[0];
      // console.log("Update redux state");
      // this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: key, subtype: "tracks", data: undefined })
      // var newlist = this.state.authortracks.filter(el => {
      //   console.log(el.key);
      //   if (el.key === key) {
      //     return false
      //   } else {
      //     return true;
      //   }
      // });
      // console.log(newlist);
      // this.setState({
      //   authortracks: newlist,
      //   pathToDelete: ""
      // }, () => {
      //   console.log(this.state.authortracks);
      // });
      // firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/tracks/" + key).set(null);

    }
    this.refs.deleteDialog.hide()
  }


  cancelDelete = () => {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  cancelDeleteauthor = () => {
    console.log("Cancel Delete");
    this.setState({
      selectedspeaker: {}
    })
    this.refs.deleteDialogauthor.hide()
  }
  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }


  appendSection(sectionName, icon, treeData) {
    // console.log("In addnew section");
    if (components != null) {
      var selectedSection = null;
      console.log("check here3");
      console.log(components);
      var componenetsdata = components.navigation.menus;
      for (let index = 0; index < componenetsdata.length; index++) {
        const element = componenetsdata[index];
        if (element.name.toLowerCase() == sectionName.toLowerCase()) {
          selectedSection = element;
        }
      }

      if (selectedSection != null) {
        //alert(selectedSection);
        var treeData = treeData;
        var slug = this.getSlug();



        //Convert to json 
        var jsRepr = JSON.stringify(selectedSection);
        //console.log(jsRepr);
        var find = 'data_point\":\"';
        var re = new RegExp(find, 'g');
        jsRepr = jsRepr.replace(re, 'data_point\":\"' + slug + '_');
        selectedSection = JSON.parse(jsRepr);
        // console.log(jsRepr);

        // console.log(treeData);
        // console.log(selectedSection);
        treeData.push(selectedSection);
        this.props.addnewsection(treeData, this.props.params.sub);

        //console.log(treeData);
        this.saveNewMenuStructure(treeData);
        window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new component <b>" + sectionName + "</b> has been added. Check it in the sections panel.", icon);
      } else {
        window.getReactInterfaceToJS().showNotification('bottom', 'right', 'warning', "We couldn't find the required component <b>" + sectionName + "</b>. Make sure you have updated the demo data in firebase.", icon);
      }
    } else {
      window.getReactInterfaceToJS().showNotification('bottom', 'right', 'danger', "Components not fetched. Pls check install manual.", icon);
    }
  }

  saveNewMenuStructure(menus) {
    firebase.app.database().ref(Config.appEditPath + '/navigation/menus').set(menus);
  }

  saveAppInfo(key, value) {
    var update = {};
    update[key] = value;
    this.setState(update);
    firebase.app.database().ref(Config.appEditPath + '/' + key).set(value);
    firebase.app.database().ref(Config.appEditPath + '/appIsSubmited').set(null);
  }


  /**
   * Saving extra sync app info
   * @param {String} value 
   * @param {String} type  shopify | wordpress
   * @param {int} rabid the id of the app
   */
  saveSyncAppInfo(value, type, rabid) {
    var objectToSave = {};
    var path = "saasraab/"
    var slug = this.getSlug();
    if (type == "shopify") {
      path += "shopifySites";
      objectToSave.firestoreCollectionForCategories = slug + "_product_collection_shopify"
      objectToSave.firestoreCollectionForProduct = slug + "_products_shopify";
      objectToSave.shopifySite = value;
    } else if (type == "wordpress") {
      path += "wordpressSites";
      objectToSave.wordpressSite = value;
    }
    path += "/" + rabid;
    firebase.app.database().ref(path).set(objectToSave);
  }

  getObjectDiff(obj1, obj2) {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key);
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key);
        result.splice(resultKeyIndex, 1);
      }
      return result;
    }, Object.keys(obj2));

    return diff;
  }
  processDataForSaving(data) {
    this.setState({
      agendatracks: data
    }, () => {
      var tosavelist = {};
      data.map((d, i) => {
        tosavelist[d.key] = { name: d.title, o: i }
      })
      console.log(tosavelist);
      firebase.app.database().ref('myapps/' + this.props.params.sub + "/agendas/tracks").set(tosavelist);
      this.props.updateobjectdatabytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: "tracks", data: tosavelist });
    });
  }

  createButton(item, theClass, treeData) {
    return <button onClick={() => {
      this.appendSection(item.componentName, item.icon, treeData);
    }} className={"btn " + theClass}><i className="material-icons">{item.icon}</i>{item.name}</button>
  }

  generateIndex(index) {
    var expandedCount = 0;
    this.state.treeData.forEach(element => {
      if (element.expanded && element.subMenus && element.subMenus.length > 0) {
        expandedCount++;
      }
    });
    return expandedCount;
  }

  formIt(path) {
    if ((path + "").indexOf(',') == -1) {
      return path;
    } else {
      return (path + "").substring((path + "").indexOf(',') + 1);
    }
  }



  refreshDataAndHideNotification(time = 3000) {
    //Hide notifications
    setTimeout(function () { this.setState({ notifications: [] }) }.bind(this), time);
  }


  sectionTabContent() {
    return (
      <div style={{ height: 400 }}>

        <SortableTree
          ref="sortableTree"
          maxDepth={0}
          // isVirtualized={false}
          treeData={this.state.agendatracks}
          canNodeHaveChildren={(item) => {
            return false
          }}
          // onChange={treeData => this.setState({ treeData })}
          onChange={data => this.processDataForSaving(data)}
          getNodeKey={getNodeKey}
          generateNodeProps={({ node, path }) => ({
            buttons: [
              <button className="btn-primary" onClick={() => {
                console.log("Clicked");
                console.log(node);
                console.log(path);
                console.log("For tracks");
                console.log(node.title);
                this.setState({
                  sectionsactive: ["", "active", "", ""],
                  trackname: node.title,
                  updatetrack: true,
                  selectedtrackname: node.title,
                  selectedtrack: node
                })
              }}>
                <i className="material-icons">edit</i>
              </button>,
              <div>
                &nbsp;&nbsp;
                <a onClick={() => {
                  this.refs.deleteDialog.show();
                  console.log("Delete");
                  this.setState({ nodeToDelete: node, pathToDelete: path })
                }} >
                  <button className="btn-danger">
                    <i className="material-icons">delete</i>
                  </button></a>
              </div>,
            ],
          })}


        />
      </div>)
  }


  addNewSectionContent(treeData) {
    // console.log("in add new section");
    // console.log(treeData);
    return (<div>

      {/* <button onClick={()=>{this.setState({showAddButton:!this.state.showAddButton})}} className="btn btn-rose"><i className={!this.state.showAddButton?"fa fa-window-restore":"fa fa-minus"}></i> {!this.state.showAddButton?"Add Master detail":"Cancel adding Master detail"}</button> */}
      <ConditionalDisplay condition={true} >
        <div>

          <hr />
          {T.td("MASTER DETAILS VIEWS")}
          <br />
          {this.state.md.map((item) => {
            return this.createButton(item, Config.designSettings.submitButtonClass, treeData);
          })}
          <hr />

        </div>
      </ConditionalDisplay>
      <div>

        <hr />
        {T.td("SPECIFIC VIEWS")}
        <br />

        {this.state.sv.map((item) => {
          return this.createButton(item, Config.designSettings.buttonSuccessClass, treeData);
        })}
        <hr />
        <br />
      </div>
    </div>)
  }

  confirmDeleteApp() {
    if (this.state.inputDelete.length > 0 && this.state.inputDelete === "delete") {
      firebase.app.database().ref(Config.appEditPath).remove();
      this.getAutoIncrementedNumOfApps();
      window.location = "#"
    } else alert(T.ts("Please write delete to confirm deleting the app"))
  }

  // checkIfCanDeleteApp(rabId) {
  //   var _this = this;
  //   var rab_pointers = firebase.app.database().ref("rab_pointers/apps_queue/" + rabId + "_both");
  //   rab_pointers.on('value', function (snapshot) {
  //     _this.setState({
  //       canDeleteApp: snapshot.val() ? false : true
  //     })
  //   });
  // }

  getAutoIncrementedNumOfApps() {
    var num_of_apps_ai = firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid + '/numOfApps');
    num_of_apps_ai.transaction(function (ai) {
      if (ai) {
        ai--;
      }
      return ai;
    }, function (e, done, ai) {
      firebase.app.database().ref('/users/' + firebase.app.auth().currentUser.uid).update({
        numOfApps: ai.val()
      });
    });
  }
  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      trackname: "",
      selectedtrack: {},
      selectedtrackname: '',
      updatetrack: false,
      updateinfobooth: false,
      selectedinfobooth: {},
      selectedinfoboothname: "",
      trackvalue: '',
      infoboothname: '',
      infoboothdes: '',
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakertrack: "",
      speakerdes: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerspeakers: null,
      speakervenue: null,
      speakersdate: "",
      speakerlocation: "",
      speakersubsection: null,
      speakersessiontype: { label: "MainSession", value: false },
      speakeredate: "",
      updatedspeaker: false
    })
  }


  basicInfoContent() {

    return (
      <div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Track name")}</label>
            <input value={this.state.trackname} name="name" onChange={(event) => {
              this.setState({ trackname: event.target.value })
            }} type="text" className="form-control" />
          </div>
        </div>
        <br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" onClick={() => {
            if (this.state.updatetrack) {
              console.log("Updating Track");

              console.log(this.state.trackname);
              console.log(this.state.selectedtrack);
              var nameoftrack = this.state.trackname;
              var keyoftrack = this.state.selectedtrack.key;
              var order = this.state.selectedtrack.o
              this.setState((prevState) => {
                return {
                  agendatracks: prevState.agendatracks.map(
                    (content, i) => content.key === keyoftrack ? { ...content, title: this.state.trackname }
                      : content
                  ),
                  trackname: "",
                  updatetrack: false,
                  selectedtrackname: '',
                  selectedtrack: {},
                  sectionsactive: ["active", "", "", ""]
                }
              }, () => {
                firebase.app.database().ref("myapps/" + this.props.params.sub + "/" + this.props.route.type + "/tracks/" + keyoftrack + "/name").set(nameoftrack).then(() => {
                  console.log("Updated");
                }).catch(err => {
                  console.log(err);
                })
                this.updatetableaftertrackupdate();
                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: this.props.route.type, key: keyoftrack, subtype: "tracks", data: { o: order, name: nameoftrack } })

                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The track <b>" + nameoftrack + "</b> has been updated.");

              });

            } else {
              console.log("Adding new track");
              console.log(this.state.trackname);
              var firebaseref = firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/tracks").push();
              var keyoftrack = firebaseref.key;
              console.log(keyoftrack);
              // var  = this.state.treeData;
              var o = this.state.agendatracks.length;
              var toupdatedata = {
                name: this.state.trackname,
                o: o
              }
              firebaseref.set(toupdatedata)
              var nameoftrack = this.state.trackname;
              this.setState((prevState) => {
                return {
                  agendatracks: [...prevState.agendatracks, {
                    key: keyoftrack,
                    title: this.state.trackname,
                    expanded: true
                  }],
                  trackname: ""
                }
              }, () => {
                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: this.props.route.type, key: keyoftrack, subtype: "tracks", data: toupdatedata })
                // this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: 'authors', key: keyoftrack, data: toupdatedata })
                // this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'infobooths', data: this.processdataforfirebase(this.state.treeData) });
                window.getReactInterfaceToJS().showNotification('bottom', 'right', 'success', "The new track <b>" + nameoftrack + "</b> has been added. Check it in the tracks panel.");
              });
            }
          }} className="btn btn-primary" disabled={this.state.updatetrack ? (this.state.trackname == this.state.selectedtrackname) : !this.state.trackname}>{T.td(this.state.updatetrack ? "Update Track" : "Add Track")}</button>
        </div>

      </div>)
  }

  componentWillMount() {
    var agendadata = {};
    var agendatracks = [];
    var agendalist = [];
    var venuedata = {};
    var speakerdata = {};

    var columns = [
      {
        Header: 'Name',
        accessor: (row) => {
          if (row.name) {
            return row.name
          } else {
            return ""
          }
        },
        id: "name",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Start Date',
        // accessor: 'post',
        accessor: (row) => {
          if (row.sdate) {
            return row.sdate;
          } else {
            return ""
          }
        },
        Cell: ({ value }) => {
          if (value != "") {
            var addtimestamp = (new Date().getTimezoneOffset() + (this.state.tzo * 60)) * 60000;
            return <div>{moment(value + addtimestamp).format('h:mm A DD MMM,YYYY')}</div>

          } else {
            return <div></div>

          }
        },
        // Cell: row => moment(row.original.sdate).format('h:mm A DD MMM,YYYY'),
        id: "sdate",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'End Date',
        accessor: (row) => {
          if (row.edate) {
            return row.edate;
          } else {
            return ""
          }
        },
        Cell: ({ value }) => {
          if (value != "") {
            var addtimestamp = (new Date().getTimezoneOffset() + (this.state.tzo * 60)) * 60000;

            return <div>{moment(value + addtimestamp).format('h:mm A DD MMM,YYYY')}</div>

          } else {
            return <div></div>

          }
        },
        id: "edate",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      }, {
        Header: 'TrackName',
        accessor: (row) => {
          if (row.trackname) {
            return row.trackname
          } else {
            return ""
          }
        },
        id: "trackname",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'SubTrack',
        accessor: (row) => {
          if (row.subtrack) {
            return row.subtrack
          } else {
            return ""
          }
        },
        id: "subtrack",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 150,

      },
      {
        Header: 'Location',
        accessor: (row) => {
          if (row.location) {
            return row.location
          } else {
            return ""
          }
        },
        id: "location",
        maxWidth: 150,
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
      },
      {
        Header: 'Venue',
        accessor: (row) => {
          if (row.venue) {
            return row.venue
          } else {
            return ""
          }
        },
        id: "venue",
        maxWidth: 150,
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
      },
      {
        Header: 'Speakers',
        accessor: (row) => {
          if (row.speakerlist) {
            return row.speakerlist
          } else {
            return ""
          }
        },
        id: "speakerlist",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        filterMethod: (filter, row) => {
          if (row[filter.id]) {
            var found = false;
            for (var i = 0; i < row[filter.id].length; i++) {
              if (row[filter.id][i].toLowerCase().includes(filter.value.toLowerCase())) {
                found = true;
                break;
              }
            }
            return found;
          } else {
            return false;
          }
        },
        Cell: ({ value }) => {

          if (value) {
            return (
              <ul>
                {value.map(v => {
                  return (
                    <li key={v}>{v}</li>
                  )
                })}
              </ul>
            )
          } else {
            return <div></div>
          }

        },
      },
      {
        Header: 'Description',
        accessor: (row) => {
          if (row.des) {
            return row.des
          } else {
            return ""
          }
        },
        id: "des",
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        Cell: ({ value }) => {
          return <div dangerouslySetInnerHTML={{ __html: value }} />
        },
      },
      {
        Header: 'Action',
        headerStyle: { whiteSpace: 'unset' },
        style: { whiteSpace: 'unset' },
        maxWidth: 100,
        Cell: row => {
          return (
            <div>
              <button className="btn-primary" onClick={() => {
                console.log(row.original);
                console.log(row.original.key);
                console.log("Edit clicked");
                var speakerlist = [];
                if (row.original.speaker) {
                  Object.keys(row.original.speaker).map(data => {
                    speakerlist.push({ value: data, label: this.state.speakerdata[data].name })
                  });
                  console.log(speakerlist);
                }
                var trackname = ""
                if (row.original.track) {
                  this.state.agendatracks.map(track => {
                    if (track.key == row.original.track) {
                      trackname = track.title;
                    }
                  })
                }
                var subsessionname = "";
                if (row.original.ms) {
                  this.state.agendalist.map(agenda => {
                    if (agenda.key == row.original.ms) {
                      subsessionname = agenda.name;
                    }
                  })
                }

                this.setState({
                  updatedspeaker: true,
                  selectedspeaker: row.original,
                  speakertrack: row.original.track ? row.original.track : "",
                  speakername: row.original.name,
                  speakersdate: row.original.sdate,
                  speakeredate: row.original.edate,
                  speakerlocation: row.original.location,
                  speakersessiontype: row.original.ms ? {
                    label: "Subsession",
                    value: true
                  } : { label: "MainSession", value: false },
                  speakersubsection: row.original.ms ? { label: subsessionname, value: row.original.ms } : null,
                  speakertrack: row.original.track ? { label: trackname, value: row.original.track } : null,
                  speakervenue: row.original.venue ? { label: row.original.venue, value: row.original.venueid } : null,
                  speakerspeakers: row.original.speaker ? speakerlist : null,
                  speakerdes: row.original.des ? row.original.des : "",
                  sectionsactive: ["", "", "", "active"],

                  dspeakertrack: row.original.track ? { label: trackname, value: row.original.track } : null,
                  dspeakervenue: row.original.venue ? { label: row.original.venue, value: row.original.venueid } : null,
                  dspeakerspeakers: row.original.speaker ? speakerlist : null,
                  dspeakersubsection: row.original.ms ? { label: subsessionname, value: row.original.ms } : null,

                })
              }
              }> <i className="material-icons">edit</i></button>
              <br /> <br />
              <button className="btn-danger" onClick={() => {
                console.log(row.original);
                console.log("Delte clicked");
                this.refs.deleteDialogauthor.show();
                this.setState({
                  selectedspeaker: row.original
                })
              }
              }> <i className="material-icons">delete</i></button>
            </div>)
        },
      },
    ];
    var tzo = new Date().getTimezoneOffset() / -60;
    if (this.props.events[this.props.params.sub]) {
      if (this.props.events[this.props.params.sub].agendas) {
        agendadata = JSON.parse(JSON.stringify(this.props.events[this.props.params.sub].agendas));
        venuedata = this.props.events[this.props.params.sub].venues;
        speakerdata = this.props.events[this.props.params.sub].speakers;
        tzo = this.props.events[this.props.params.sub].extradata.tzo;
        if (!tzo) {
          tzo = new Date().getTimezoneOffset() / -60;
        }
        console.log(agendadata);
        console.log(speakerdata);
        var tracks = agendadata.tracks ? agendadata.tracks : {};
        var agendas = agendadata.agenda ? agendadata.agenda : {};
        Object.keys(agendas).map((agenda) => {
          var d = agendas[agenda];
          d["key"] = agenda;
          if (!d.des) {
            d["des"] = "";
          }
          if (d.track) {
            d["trackname"] = tracks[d.track].name
          }
          if (d.ms) {
            d["subtrack"] = agendas[d.ms].name
          }
          if (d.venue) {
            if (venuedata.venue) {
              if (d.venue in venuedata.venue) {
                var venueid = d.venue;
                d["venue"] = venuedata.venue[venueid].name;
                d["venueid"] = venueid;
              }
            }
          }
          if (d.speaker) {
            if (speakerdata) {
              var list = [];
              Object.keys(d.speaker).map(speaker => {
                if (speaker in speakerdata) {
                  list.push(speakerdata[speaker].name)
                }
              });
              console.log("SPeaker list");
              console.log(list);
              d["speakerlist"] = list;
            }
          }
          agendalist.push(d);
        });
        Object.keys(tracks).map(track => {
          var mdata = tracks[track];
          var data = {};
          data["key"] = track;
          data["o"] = mdata.o;

          data["expanded"] = true;
          data["title"] = mdata.name;
          agendatracks.push(data);
        });
        agendatracks = _.sortBy(agendatracks, "o");
      }
    }

    this.setState({
      agendalist: agendalist,
      agendatracks: agendatracks,
      columns: columns,
      venuedata: venuedata,
      speakerdata: speakerdata,
      tzo: tzo,
    });
    // console.log(JSON.stringify(categories));


  }
  updatetableaftertrackupdate = () => {
    // console.log(this.state.authortracks);
    var trackdata = _.keyBy(this.state.agendatracks, 'key');
    console.log(trackdata);
    var newlist = [];
    this.state.agendalist.map(auth => {
      if (auth.track) {
        if (trackdata[auth.track]) {
          auth.trackname = trackdata[auth.track].title;
        } else {
          auth.trackname = "";
        }
      }

      newlist.push(auth);
    })
    console.log(newlist);
    this.setState({
      agendalist: newlist
    })
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  authortable() {
    return (
      <div style={{ padding: '50px' }}>
        <ReactTable
          PaginationComponent={Pagination}

          data={this.state.agendalist}
          columns={this.state.columns}
          sortable={true}
          multiSort={true}
          filterable={true}
          defaultSorted={[
            {
              id: "sdate",
              desc: false
            }
          ]}
          defaultFilterMethod={(filter, row) => { return row[filter.id].toLowerCase().includes(filter.value.toLowerCase()) }}
        />
      </div>

    )
  }
  gotomainlist() {
    this.setState({
      sectionsactive: ["", "", "active", ""],
      selectedspeaker: {},
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerdes: "",
      speakertrack: "",
      speakerlocation: "",
      speakersessiontype: { label: "MainSession", value: false },
      speakervenue: null,
      speakeredate: "",
      speakersdate: '',

    })
  }
  doedit(d) {
    console.log("in edit");
    var key = this.state.selectedspeaker.key;
    console.log(d);
    console.log("Update redux state");
    if (d.company == "") {
      delete d.company;
    }
    if (d.post == "") {
      delete d.post;
    }
    if (d.des == "") {
      delete d.des;
    }
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/author/" + key).update(d);
    this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: 'authors', key: key, subtype: "author", data: d })
    var trackdata = _.keyBy(this.state.authortracks, 'key');
    console.log(trackdata);
    console.log(trackdata[this.state.speakertrack].title);
    d["trackname"] = trackdata[this.state.speakertrack].title;
    // this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: d })
    console.log("Updating local state");
    this.setState({
      authorlist: this.state.authorlist.map(el => (el.key === key ? { ...el, ...d } : el))
    }, () => {
      console.log(this.state.tdata);
    });
    console.log("Saving to firebase");

    console.log(d);

    this.gotomainlist();

  }
  addspeaker() {
    var options = [];
    var speakeroption = [];
    var subsection = false;
    var tracksoption = [];
    var subsectionoption = [];
    var speakersessiontypeoption = [
      {
        label: "MainSession",
        value: false
      },
      {
        label: "Subsession",
        value: true
      }
    ]
    if (this.state.venuedata && this.state.venuedata.venue) {
      options.push({
        value: null,
        label: ""
      })
      Object.keys(this.state.venuedata.venue).map(venue => {
        options.push({
          label: this.state.venuedata.venue[venue].name,
          value: venue
        })
      })
    }
    if (this.state.speakerdata) {
      Object.keys(this.state.speakerdata).map(speaker => {
        speakeroption.push({
          label: this.state.speakerdata[speaker].name,
          value: speaker
        })
      })
    }

    var addtimestamp = (new Date().getTimezoneOffset() + (this.state.tzo * 60)) * 60000;

    // console.log(this.state.speakersessiontype)
    if (this.state.speakersessiontype.value) {
      this.state.agendalist.map(agenda => {
        if (!agenda.ms) {

          subsectionoption.push({
            label: agenda.name,
            value: agenda.key,
            subLabel: agenda.location ? agenda.location + "-" + moment(agenda.sdate + addtimestamp).format('h:mm A DD MMM,YYYY') : moment(agenda.sdate + addtimestamp).format('h:mm A DD MMM,YYYY'),

          })
        }
        // subsection
      })
    } else {
      this.state.agendatracks.map(track => {
        tracksoption.push({
          label: track.title,
          value: track.key
        })
      })
    }



    // console.log(options);
    // console.log(speakeroption);
    return (
      <div className="center col-md-12 ml-auto mr-auto">
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Agenda name")}</label>
            <input value={this.state.speakername} name="name" onChange={(event) => {
              this.setState({
                speakername: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>

          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Start Date")}
            </label>
            <DT
              onChange={(event) => {
                console.log(event.valueOf());
                this.setState({
                  speakersdate: event.valueOf()
                })
              }}
              value={this.state.speakersdate}
            />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">date_range</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("End Date")}
            </label>
            <DT
              onChange={(event) => {
                console.log(event.valueOf());
                this.setState({
                  speakeredate: event.valueOf()
                })
              }}
              // input={false}
              value={this.state.speakeredate}
            // dateFormat={this.props.dateFormats.dateFormat}
            // timeFormat={this.props.dateFormats.timeFormat}
            // locale={this.props.dateFormats.locale || "en"} 
            />
          </div>
        </div>
        <br />
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">class</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Session Type")}
            </label>
            <Select
              value={this.state.speakersessiontype}
              onChange={(speakersessiontype) => {

                this.setState({ speakersessiontype });
              }}
              options={speakersessiontypeoption}
            />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">class</i>
          </span>
          {!this.state.speakersessiontype.value ?
            <div className="form-group label-floating">
              <label className="control-label">{T.td("Select Track")}
              </label>
              <Select
                value={this.state.speakertrack}
                onChange={(speakertrack) => {
                  this.setState({ speakertrack });
                }}
                options={tracksoption}
              />
            </div>
            :

            <div className="form-group label-floating">
              <label className="control-label">{T.td("Select Session")}
              </label>
              <Select
                components={{ Option: selectrender }}
                value={this.state.speakersubsection}
                onChange={(speakersubsection) => {
                  this.setState({ speakersubsection });
                }}
                options={subsectionoption}
              />
            </div>}
        </div>

        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">border_color</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Location")}</label>
            <input value={this.state.speakerlocation} name="name" onChange={(event) => {
              this.setState({
                speakerlocation: event.target.value
              })
              // this.saveAppInfo("name", event.target.value);
            }} type="text" className="form-control" />
          </div>
          <span className="input-group-addon">
            <i className="material-icons">class</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Venue")}
            </label>
            <Select
              value={this.state.speakervenue}
              onChange={(speakervenue) => {
                this.setState({ speakervenue });
              }}
              options={options}
            />
          </div>
        </div>
        <div className="input-group">
          <span className="input-group-addon">
            <i className="material-icons">class</i>
          </span>
          <div className="form-group label-floating">
            <label className="control-label">{T.td("Speakers")}
            </label>
            <Select
              value={this.state.speakerspeakers}
              onChange={(speakerspeakers) => {
                this.setState({ speakerspeakers });
              }}
              isMulti={true}
              options={speakeroption}
            />
          </div>
        </div>
        <br />


        <br />
        <div className="form-group">
          <label>{T.td("Agenda Description")}</label>
          <HTML theKey={"htmlkey"} value={this.state.speakerdes} updateAction={(data) => {
            this.setState({
              speakerdes: data
            })
          }}></HTML>

        </div>


        {/*<button type="button" className="btn btn-primary" data-toggle="modal" data-target="#modalCookie1">{T.td("Delete App")}</button>*/}
        <br /><br />
        <div className="col-md-6 col-md-offset-3">
          <button type="button" className="btn btn-primary"
            onClick={() => {
              console.log(this.state.speakername);
              console.log(this.state.speakersdate);
              console.log(this.state.speakeredate);
              console.log(this.state.speakervenue);
              console.log(this.state.speakertrack);
              console.log(this.state.speakersessiontype);
              console.log(this.state.speakersubsection);
              console.log(this.state.speakerdes);
              console.log(this.state.selectedspeaker);

              console.log("Saving to database and redux");

              console.log(this.state.speakerspeakers);
              console.log(this.state.dspeakerspeakers)


              if (isNaN(this.state.speakeredate) || isNaN(this.state.speakersdate)) {
                alert("Please check your date");
                return;
              }
              if (this.state.speakeredate < this.state.speakersdate) {
                alert("Start date cannot be greater than end date");
                return;
              }
              if (this.state.speakersessiontype.value) {
                if (this.state.selectedspeaker.ss) {
                  alert("This agenda has subsections. Please update them");
                  return;
                }
              }
              var d = {};

              d.name = this.state.speakername;
              d.sdate = this.state.speakersdate;
              d.edate = this.state.speakeredate;
              if (this.state.speakersessiontype.value) {
                if (this.state.speakersubsection) {
                  d.ms = this.state.speakersubsection.value;
                } else {
                  alert("Please select a subsection");
                  return;
                }
              } else {
                if (this.state.speakertrack) {
                  d.track = this.state.speakertrack.value
                } else {
                  alert("Please select a track");
                  return;
                }
              }
              if (this.state.speakerspeakers) {
                var speakerlist = {};
                this.state.speakerspeakers.map(speaker => {
                  speakerlist[speaker.value] = true;
                })
                d["speaker"] = speakerlist;
              }
              console.log(this.state.speakervenue);
              if (this.state.speakervenue) {
                d["venue"] = this.state.speakervenue.value;
              }
              if (this.state.speakerdes && this.state.speakerdes !== "") {
                d["des"] = this.state.speakerdes;
              } else {
                delete d["des"];
              }

              if (this.state.speakerlocation && this.state.speakerlocation !== "") {
                d["location"] = this.state.speakerlocation;
              } else {
                delete d["location"];
              }

              var p = JSON.parse(JSON.stringify(d));
              if (this.state.speakerspeakers) {
                var speakerlist = [];
                this.state.speakerspeakers.map(speaker => {
                  speakerlist.push(speaker.label);
                })
                p["speakerlist"] = speakerlist;
              }
              if (this.state.speakervenue) {
                p["venue"] = this.state.speakervenue.label;
              }
              if (this.state.speakersessiontype.value) {
                p["subtrack"] = this.state.speakersubsection.label;
              } else {
                p["trackname"] = this.state.speakertrack.label
              }
              // p["key"] = this.state.selectedspeaker.key;
              console.log(p);
              if (this.state.updatedspeaker) {
                console.log("Updating speaker");
                console.log(d);
                console.log(p);
                var update = {};
                if (!_.isEqual(this.state.speakersubsection, this.state.dspeakersubsection)) {
                  if (this.state.dspeakersubsection) {
                    if (this.state.dspeakersubsection.value) {
                      update["myapps/" + this.props.params.sub + "/" + this.props.route.type + "/agenda/" + this.state.dspeakersubsection.value + "/ss/" + this.state.selectedspeaker.key] = null;
                    }
                  }
                  if (this.state.speakersubsection) {
                    if (this.state.speakersubsection.value) {
                      update["myapps/" + this.props.params.sub + "/" + this.props.route.type + "/agenda/" + this.state.speakersubsection.value + "/ss/" + this.state.selectedspeaker.key] = true;
                    }
                  }
                }
                update["myapps/" + this.props.params.sub + "/" + this.props.route.type + "/agenda/" + this.state.selectedspeaker.key] = d;

                console.log(update);
                firebase.app.database().ref().update(update);
                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: this.props.route.type, key: this.state.selectedspeaker.key, subtype: "agenda", data: d })
                p["key"] = this.state.selectedspeaker.key;
                p["venueid"] = this.state.speakervenue.value ? this.state.speakervenue.value : "";

                this.setState({
                  agendalist: this.state.agendalist.map(el => (el.key === this.state.selectedspeaker.key ? { ...p } : el))
                }, () => {
                  // console.log(this.state.tdata);
                });
                this.gotomainlist();

                // this.doedit(d);
              } else {
                console.log(JSON.stringify(d));

                var speakercreate = firebase.app.database().ref("myapps/" + this.props.params.sub + "/" + this.props.route.type + "/agenda").push();
                var speakerkey = speakercreate.key;
                p["key"] = speakerkey;
                p["venueid"] = this.state.speakervenue && this.state.speakervenue.value ? this.state.speakervenue.value : "";
                if (this.state.speakersessiontype.value) {
                  firebase.app.database().ref("myapps/" + this.props.params.sub + "/" + this.props.route.type + "/agenda/" + this.state.speakersubsection.value + "/ss/" + speakerkey).set(true);
                }
                speakercreate.set(d)

                this.props.updatedataobjectbytypeandsubtype({ eventkey: this.props.params.sub, type: this.props.route.type, key: speakerkey, subtype: "agenda", data: d })
                console.log(JSON.stringify(d));



                // var trackdata = _.keyBy(this.state.authortracks, 'key');
                // console.log(trackdata);
                // console.log(trackdata[this.state.speakertrack].title);
                // d["trackname"] = trackdata[this.state.speakertrack].title;
                console.log()
                this.setState({
                  agendalist: [...this.state.agendalist, p]
                }, () => {
                  console.log(this.state.agendalist);
                });

                this.gotomainlist();
              }
            }
            }
            disabled={this.state.updatedspeaker ? ((this.state.speakername == this.state.selectedspeaker.name) && (this.state.speakersdate == this.state.selectedspeaker.sdate) && (this.state.speakeredate == this.state.selectedspeaker.edate) && (this.state.speakerlocation == this.state.selectedspeaker.location) && (this.state.speakerdes == this.state.selectedspeaker.des) && (_.isEqual(this.state.speakerspeakers, this.state.dspeakerspeakers)) && (_.isEqual(this.state.speakervenue, this.state.dspeakervenue)) && (_.isEqual(this.state.speakertrack, this.state.dspeakertrack)) && (_.isEqual(this.state.speakersubsection, this.state.dspeakersubsection))) || !(this.state.speakername && this.state.speakersdate && this.state.speakeredate && (this.state.speakersessiontype.value ? this.state.speakersubsection : this.state.speakertrack))
              : !(this.state.speakername && this.state.speakersdate && this.state.speakeredate && (this.state.speakersessiontype.value ? this.state.speakersubsection : this.state.speakertrack))
            }>
            {T.td(this.state.updatedspeaker ? "Update " + this.props.route.name : "Add " + this.props.route.name)}
          </button>
        </div>

      </div >)
  }
  render() {
    var tracktitle = this.state.updatetrack ? "Update Track" : "Add new Track";

    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td("Tracks"),
        active: this.state.sectionsactive[0],
        label1: T.ts("Drag n Drop them Also you can nest them"),
        label2: T.td("Track sections"),
        content: this.sectionTabContent()
      },
      {
        name: "sectionsadd",
        icon: "playlist_add",
        title: T.td("Add Track"),
        active: this.state.sectionsactive[1],
        label1: T.ts(tracktitle),
        content: this.basicInfoContent()
      },
      {
        name: "authorlist",
        icon: "subject",
        title: T.td(this.capitalize(this.props.route.type)),
        active: this.state.sectionsactive[0],
        label1: T.ts(this.capitalize(this.props.route.type) + " List"),
        content: this.authortable()
      }, {
        name: "images",
        icon: "collections",
        title: T.td("Add " + this.props.route.name),
        active: this.state.sectionsactive[1],
        label1: T.td("Add " + this.props.route.name),
        content: this.addspeaker()
      }
    ];

    return (
      <div>
        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Section name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.nodeToDelete.title}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>
        <SkyLight hideOnOverlayClicked ref="deleteDialogauthor" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td("Section name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.selectedspeaker.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.cancelDeleteauthor()} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDeleteauthor()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>


          <Wizzard
            title={"Agenda"}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />
        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updateobjectwithtracks: dispatch.eventmodel.updateobjectwithtracks,
  updatedataobjectbytypeandsubtype: dispatch.eventmodel.updatedataobjectbytypeandsubtype,
  updateobjectdatabytype: dispatch.eventmodel.updateobjectdatabytype
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Agenda);


// WEBPACK FOOTER //
// ./src/containers/Builder/agenda.js